module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/commentStar.67ab9b35.svg";